import { render, staticRenderFns } from "./ChangeLanguageButton.vue?vue&type=template&id=16325a6e&"
import script from "./ChangeLanguageButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChangeLanguageButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16325a6e')) {
      api.createRecord('16325a6e', component.options)
    } else {
      api.reload('16325a6e', component.options)
    }
    module.hot.accept("./ChangeLanguageButton.vue?vue&type=template&id=16325a6e&", function () {
      api.rerender('16325a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/components/ChangeLanguageButton.vue"
export default component.exports